'use strict';

function NotificationCentre() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_ErrorController];
  this._msgList = $('<div class="notification-message-list"></div>');

  this.init = function () {
    this._ms = new MessageService(this.presenter);
    this._readAllCta = $(this.node).find('.js--read-all-cta');
    this._readAllCta.on('click', this._readAllMessages.bind(this));
    this._spinner = $('.js--loading-spinner');
    // the bell icon should be hidden on mobile view when opening the notification centre
    this._mobileNotificationIcon = $('.js--mobile-notification-icon');
    this._mobileNotificationIcon.hide();
  };

  this.initAllReady = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this._populateMessages();
    this._seeAllMessages();
  };

  this._populateMessages = function () {
    var _this = this;

    this._ms.loadMessages(function (data, status) {
      var msgs = data ? data.messages : null;
      _this.analytics.pushEvent('nc-notification-status', {
        message: [msgs ? msgs.length : 0]
      });
      if (msgs && msgs.length > 0) {
        msgs.forEach(function (msg, index) {
          var msgElm = $('<div></div>');
          _this._msgList.append(msgElm);
          msgElm.mogo().create('Message', {
            presenter: _this.presenter,
            msgIndex: index,
            failCallback: _this._connectionErrorHandler.bind(_this)
          });
        });
        $('.js--message-modal-body').append(_this._msgList);
      } else {
        _this._connectionErrorHandler(data, status, 'account.index_messages');
        if (data && data.errors) {
          console.warn(data.errors);
        }
      }
    }, true);
  };

  this._connectionErrorHandler = function (data, status, action) {
    if (this.isGeneralConnectionIssue(data, status)) {
      this._msgList.addClass('hide');
      this._readAllCta.addClass('hide');
      this._spinner.addClass('hide');
      this.invokeConnectionIssuePage({ action: action }, {
        productLabel: 'MogoMember'
      }, function (data, status) {
        if (status === 200) {
          this._msgList.removeClass('hide');
          this._readAllCta.removeClass('hide');
        }
      }, {
        node: $('.no-message')[0],
        view: '/member/home/tray-notification-centre-connection-error',
        isEntirePage: false
      });
    }
  };

  this._seeAllMessages = function () {
    var _this2 = this;

    this._ms.updateMessagesInBulk('seen', function (data, status) {
      if (status == 200) {
        _this2.presenter.setModelProperty('account.unseen_message_count', data.unseen_message_count);
      } else {
        _this2._connectionErrorHandler(data, status, 'messages.bulk_update_messages');
        if (data && data.errors) {
          console.warn(data.errors);
        }
      }
    });
  };

  this._readAllMessages = function () {
    var _this3 = this;

    this._ms.updateMessagesInBulk('read', function (data, status) {
      if (data || status == 200) {
        _this3._readAllCta.addClass('hide');
        $(_this3.node).find('[data-mogo-ui="Message"]').addClass('read-message');
      } else {
        _this3._connectionErrorHandler(data, status, 'messages.bulk_update_messages');
        if (data && data.errors) {
          console.warn(data.errors);
        }
      }
    });
  };

  this.destroy = function () {
    // the bell icon should be displayed on mobile view when closing the notification centre
    if (this._mobileNotificationIcon.length > 0) {
      this._mobileNotificationIcon.show();
    }
    if (this._ms) {
      this._ms.destroy();
    }
    delete this.presenter.models.messages;
    this._liveChat = $('.js--live-chat');
    if (this._liveChat.length > 0 && this._liveChat.mogo() && this._liveChat.mogo().clear) {
      this._liveChat.mogo().clear();
    }
  };
}